import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import { OutlinedInput } from "@mui/material";
import { useEffect, useState } from "react";
import { TableColumn } from "react-data-table-component";
import { Params, useLocation, useNavigate, useParams } from "react-router-dom";
import Table from "../../../../ui/components/table/table";
import { Convenio } from "../../../models/convenio";
import { ConvenioPractica } from "../../../models/convenio-practica";
import { convenioServices } from "../../../services/convenio.services";
import {
  getFormattedDate,
  getFormattedDecimal,
} from "../../../utils/common.utils";
import {
  initialFilter,
  queryParamsConfig,
} from "../../../utils/convenio-practica.utils";
import { useQueryParamsReplace } from "../../../utils/useQueryParamsReplace";
import "./convenio-view.scss";

export default function ConvenioViewList() {
  const { id } = useParams<Params>();
  const [queryParams, setQueryParams] =
    useQueryParamsReplace(queryParamsConfig);
  const [fetching, setFetching] = useState<boolean>(true);
  const [entities, setEntities] = useState<ConvenioPractica[]>([]);
  const [convenio, setConvenio] = useState<Convenio>();
  const [totalCount, setTotalCount] = useState<number>(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (id) {
      getConvenio();
    }
  }, [id]);

  useEffect(() => {
    if (location.search === "") {
      setQueryParams(initialFilter);
    }
    if (queryParams.page && id) {
      getPracticasConvenio();
    }
  }, [queryParams]);

  const getConvenio = async () => {
    if (id) {
      setFetching(true);
      convenioServices
        .getById(id)
        .then((response) => {
          setFetching(false);
          setConvenio(response.data);
        })
        .catch((error) => {});
    }
  };

  const getPracticasConvenio = async () => {
    if (id) {
      let params = { ...queryParams };
      params = { ...params, active: true };
      setFetching(true);
      setEntities([]);
      convenioServices
        .getPracticasList(id, params)
        .then((response) => {
          setFetching(false);
          setEntities(response.data.items);
          setTotalCount(response.data.totalItems);
        })
        .catch((error) => {});
    }
  };

  const columns: TableColumn<ConvenioPractica>[] = [
    {
      name: "Nº Práctica",
      selector: (row) => row.numeroPractica,
      width: "12%",
      sortable: true,
      sortField: "numero_practica",
    },
    {
      name: "Nombre",
      selector: (row) => row.descripcion,
      sortable: true,
      sortField: "nombre",
    },
    // Only show Antigüedad columns if convenio?.consideraAntiguedad !== false
    ...(convenio?.consideraAntiguedad !== false
      ? [
          {
            name: "Antigüedad Mínima",
            selector: (row: ConvenioPractica) => row.antiguedadMinima,
            width: "10%",
          },
          {
            name: "Antigüedad Máxima",
            selector: (row: ConvenioPractica) => row.antiguedadMaxima,
            width: "10%",
          },
        ]
      : []),
    {
      name: "Precio",
      cell: (row) => (
        <div className="table-cell-right">
          {getFormattedDecimal(row.precio)}
        </div>
      ),
      width: "10%",
    },
    {
      name: "Coseguro",
      cell: (row) => (
        <div className="table-cell-right">
          {getFormattedDecimal(row.coseguro)}
        </div>
      ),
      width: "10%",
    },
    {
      name: "Tipo",
      selector: (row) => row.tipo,
      width: "15%",
    },
  ];

  return (
    <div className="convenio-view-container">
      {convenio && (
        <div className="convenio-header">
          <button
            type="button"
            className="convenio-back-btn"
            onClick={() => navigate(-1)}
            title="Volver"
          >
            <ArrowBackIosNewOutlinedIcon fontSize="medium" />
          </button>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 4,
              flex: 1,
            }}
          >
            <h2
              style={{
                margin: 0,
                fontSize: "1.5rem",
                color: "#334155",
                fontWeight: 700,
              }}
            >
              {convenio.nombre}
            </h2>
            <div style={{ fontSize: "1rem", color: "#64748b", marginTop: 2 }}>
              <span className="vigencia">Vigencia:</span>
              {convenio.fechaInicio
                ? ` ${getFormattedDate(convenio.fechaInicio.toString())}`
                : ""}
              {convenio.fechaFin
                ? ` - ${getFormattedDate(convenio.fechaFin.toString())}`
                : " - Actualidad"}
            </div>
          </div>
        </div>
      )}
      <div className="row action-button">
        <OutlinedInput
          type={"text"}
          placeholder="Nro. de práctica, nombre"
          className={`custom-input-search`}
          autoComplete="off"
          onChange={(event) => {
            setQueryParams({
              ...queryParams,
              search:
                event.target.value !== "" ? event.target.value : undefined,
            });
          }}
        ></OutlinedInput>
      </div>
      <div className="row">
        <div className="convenios-table">
          <Table
            table={{
              columns,
              data: entities,
              paginationTotalRows: totalCount,
              highlightOnHover: true,
            }}
            setQueryParams={setQueryParams}
            queryParams={queryParams}
          ></Table>
        </div>
      </div>
    </div>
  );
}
